import React from 'react';
import { Box, Dialog, makeStyles } from '@material-ui/core';
import Process from 'src/views/shared/Process/Process';
import { workflowToElements } from 'src/views/shared/flowProcess';
import Card from 'src/components/Card';
import { isNode } from 'react-flow-renderer';
import useModal from '../../components/Modal/useModal';
import { IS_COMPLETED, IS_FOCUSED, IS_GREYED } from './Process/constants';
import { EventDetail, WorkflowWithStepsAndEdges } from '../../types';
import Loader from '../../components/Loader';

const useStyles = makeStyles((theme) => ({
  isCompleted: {
    '& .react-flow__edge-path': {
      stroke: theme.palette.success.main,
      opacity: 0.25,
    }
  },
  dialogPaper: {
    minHeight: '90vh',
    maxHeight: '90vh',
    borderRadius: theme.spacing(3)
  },
  process: {
    minHeight: '100vh',
    minWidth: '100%',
  }
}));

const engagementElements = (elements: any[], currentStepId: string, completedStepIds: string[]) => elements.map(
  (element: any) => {
    if (isNode(element) && element.id === currentStepId) {
      return {
        ...element,
        data: {
          ...element.data,
          nodeStyle: IS_FOCUSED
        },
      };
    }
    if (isNode(element) && completedStepIds.includes(element.id)) {
      return {
        ...element,
        data: {
          ...element.data,
          nodeStyle: IS_COMPLETED
        },
      };
    }
    if (isNode(element)) {
      return {
        ...element,
        data: {
          ...element.data,
          nodeStyle: IS_GREYED
        },
      };
    }
    return element;
  }
);

interface Props {
  events: EventDetail[],
  currentStepId: string,
  workflow: WorkflowWithStepsAndEdges,
  isLoading: boolean,
}

const EngagementProcess = ({
  workflow,
  currentStepId,
  events,
  isLoading,
}: Props) => {
  const elements = workflowToElements(workflow);
  // @ts-ignore - we are filtering out events without completed steps
  const completedStepIds = events.filter((event) => event.completedStep).map((event) => event.completedStep.id);
  const focusedElements = engagementElements(elements, currentStepId, completedStepIds);
  const classes = useStyles();
  const {
    isOpen, openModal, closeModal
  } = useModal();

  return (
    <>
      {
        isOpen && (
          <Dialog
            classes={{ paper: classes.dialogPaper }}
            maxWidth="xl"
            onClose={closeModal}
            open
            keepMounted
            fullWidth
          >
            <Box height="100%" width="100%" display="flex" flex="1 1" overflow="hidden">
              <Process
                id={`process-modal-${workflow.id}`}
                elements={focusedElements}
                nodesDraggable={false}
                nodesConnectable={false}
                elementsSelectable={false}
                zoomOnScroll={false}
                zoomOnDoubleClick={false}
                focusedNodeId={currentStepId}
                className={classes.process}
              />
            </Box>
          </Dialog>
        )
      }
      <Card title="Progress">
        <Box height="300px" display="flex" flex="1 1" onClick={() => openModal()}>
          {
            isLoading ? (
              <Loader />
            ) : (
              <Process
                id={`process-${workflow.id}`}
                elements={focusedElements}
                nodesDraggable={false}
                nodesConnectable={false}
                elementsSelectable={false}
                zoomOnScroll={false}
                zoomOnDoubleClick={false}
                focusedNodeId={currentStepId}
                paneMoveable={false}
              />
            )
          }
        </Box>
      </Card>
    </>
  );
};

export default EngagementProcess;
